import { Component, OnInit, ViewChild } from '@angular/core';
import { Platform, ModalController, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService, NativeService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { GridBaseCase } from '../../../grid/grid.base.case';
import { WebParameterContext } from 'src/model/common';
import { QrcodeGroupPage } from '../../qrcode-group/qrcode-group.page'

declare var app;
@Component({
  selector: 'app-nestmom-group',
  templateUrl: './nestmom-group.component.html',
  styleUrls: ['./nestmom-group.component.scss']
})
export class NestmomGroupComponent extends GridBaseCase implements OnInit {
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  PageNumber: any;
  dataArrayList: Array<any> = [];//数据列表
  searchValue: any = null;
  dataList1: any = [];//孕期小工具
  dataList2: any = [];//宝妈小工具
  initLoadData: boolean = true;
  isLoadAllData: boolean = false;//数据是否加载完成
  clickLoadMoreData: boolean = false;//点击加载更多数据
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    private native: NativeService,
    public baseService: BaseCase,
    public base: BaseModal,
    public modal: ModalController,
  ) {
    super();
    // setTimeout(()=>{
    //   this.LoadData(1);
    // },3000)
    this.LoadData(1);
   
  }

  ngOnInit() {
  }
  //  点击二维码弹窗
  async qcordDetail(item) {
    console.log("点击弹窗")
    const that = this;
    if(item.a_AppletSunCode){
      item.a_AppletSunCode=item.a_AppletSunCode.replace(app.ImagePlaceholder,app.BigImageType);
    }
    const modal = await that.modal.create({
      component: QrcodeGroupPage,
      componentProps: {
        "url": item.a_AppletSunCode,
        "name": item.a_AppletName
      }
    });
    await modal.present();
    // return await modal.present();
    const { data } = await modal.onWillDismiss();
    console.log(data, "onWillDismiss");
  }
  loadMoreData(event) {
    let that = this;
    const len = that.dataList1.length + that.dataList2.length;
    if (that.RecordCount == len) {
      that.isLoadAllData = true;
    } else if (that.RecordCount == that.dataArrayList.length) {
      that.clickLoadMoreData = true;
      that.dataList1 = [];
      that.dataList2 = [];
      that.dataArrayList.forEach(item => {
        if (item.a_Type === 1) {
          that.dataList1.push(item);
        } else if (item.a_Type == 0) {
          that.dataList2.push(item);
        }
      })
      that.clickLoadMoreData = false;
      that.isLoadAllData = true;
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
      that.clickLoadMoreData = true;
    }
  }


  LoadData(PageNumber) {
    var that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }

    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;

    body.ConfigName = "TBCmtToolsXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 10;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    if (that.searchValue) {
      let Obj = {
        a_CRMName: that.com.LikeSearch(that.searchValue)
      };
      body.RequestBody = JSON.stringify(Obj);
    }
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      that.clickLoadMoreData = false;
      if (PageNumber == 1) {
        that.dataArrayList = [];
        that.dataList1 = [];
        that.dataList2 = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else if (PageNumber == 2) {
        that.dataList1 = [];
        that.dataList2 = [];
        that.dataArrayList.forEach(item => {
          if (item.a_Type === 1) {
            
           
              that.dataList1.push(item);
           
          } else if (item.a_Type == 0) {
            setTimeout(()=>{
              that.dataList2.push(item);
            },3000)
           
           
          }
        })
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        // debugger;
        data.Status.Datas.forEach((item, index) => {

          if (item.a_AppletIcon) {
            item.a_AppletIcon = (app.FileUoloadUrl + item.a_AppletIcon).replace(app.ImagePlaceholder,app.SmallImageType);
          }
          if (item.a_AppletSunCode) {
            item.a_AppletSunCode = (app.FileUoloadUrl + item.a_AppletSunCode).replace(app.ImagePlaceholder,app.BigImageType);
          }
          if (item.a_Type === 1) {
            // if (!that.initLoadData || index < 3 || data.Status.RecordCount <= 10) {
              
            that.dataList1.push(item);
          } else if (item.a_Type == 0) {
            that.dataList2.push(item);
          }
          that.dataArrayList.push(item);
        });
        if (PageNumber == 1) {
          
          that.dataList1.length > 3 ? that.dataList1.splice(3) : false;
          that.dataList2.length > 3 ? that.dataList2.splice(3) : false;
          // that.initLoadData = false;
        }
        // that.dataArrayList = data.Status.Datas;
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        const len = that.dataList1.length + that.dataList2.length;
        if (that.RecordCount == len) {
          // that.infiniteScroll.disabled = true;
          that.isLoadAllData = true;
        } else {
          that.isLoadAllData = false;
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      // console.log(error);
    });
  }


  searchEvent(e, type: string = 'type') {

    const that = this;
    if (e.keyCode == 13 || type == 'search') {
      that.LoadData(1);
    }
  }

  /**
   * 获取更多数据
   */
  getMoreData() {
    const that = this;
    that.clickLoadMoreData = true;

  }
}
